module.exports = __webpack_public_path__ + "files/ce9f5a1737d4f62cbcffd0e1a00364ec.mp3";